import { takeLatest, put } from 'redux-saga/effects';
import { browserHistory } from 'react-router';
import * as createAppointment from '../requests/create-appointment-req';
import { actions as recordActions } from '../record';
import { DASHBOARD } from '../../../constants/routes';

export function* addRecordWorker() {
  yield put(recordActions.clear());
  browserHistory.replace(DASHBOARD);
}

export default function* addRecordSaga() {
  yield takeLatest(createAppointment.consts.SUCCEED, addRecordWorker);
}



// WEBPACK FOOTER //
// ./src/redux/dashboard/sagas/add-record-saga.js